import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { IconColor } from '../../common/icon/icon.component';
import { NotificationStyle } from '../notification-config';

@Component({
  selector: 'rt-notification-icon',
  templateUrl: './notification-icon.component.html',
  styleUrls: ['./notification-icon.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotificationIconComponent {
  @Input() public notificationStyle: NotificationStyle;

  public NotificationStyle = NotificationStyle;
  public IconColor = IconColor;
}
